export default __webpack_public_path__ + "static/media/dad.12328899.png";